<a *ngIf="searchedAndLinkedData; else showSearchAndLink" nz-dropdown [nzDropdownMenu]="searchAndLinkActionDropdown">
    {{searchedAndLinkedData}}
    <span nz-icon nzType="down"></span>
</a>

<ng-template #showSearchAndLink>
    <button nz-button nzType="link" class="p-0-force"
        (click)="openSearchAndLinkModal()">{{searchAndLinkLabel}}</button>
</ng-template>

<nz-dropdown-menu #searchAndLinkActionDropdown="nzDropdownMenu">
    <ul nz-menu>
        <li nz-menu-item (click)="changeSearchedAndLinkedData()">
            <span nz-icon nzType="edit" nzTheme="outline" class="m-r-5"></span>Change/Update
        </li>
        <li nz-menu-item (click)="removeSearchedAndLinkedData()">
            <span nz-icon nzType="delete" nzTheme="outline" class="m-r-5"></span>Remove
        </li>
    </ul>
</nz-dropdown-menu>

<nz-modal [(nzVisible)]="showSearchAndLinkModal" [nzTitle]="searchAndLinkLabel" nzWidth = "70vw" [nzMaskClosable]="false"
            [nzOkDisabled]="!(selectedListOfData && selectedListOfData.length>0)" (nzOnCancel)="handleSearchAndLinkCancel()" (nzOnOk)="addSearchAndLinkData()">
    <div>
        <ng-container *nzModalContent>
            <nz-skeleton *ngIf="!UIConfiguration"></nz-skeleton>

            <ng-container *ngIf="UIConfiguration">
            <h3 translate>{{searchTitle}}</h3>
            <div style="width:50%">
                <app-ui-search [(SearchCriteria)]="CRITERIA_LOOKUP" 
                        (componentOutput)="fetchSearchResult($event)"
                        [searchURL]="UIConfiguration['searchURL']" 
                        [itemsPerPage]="UIConfiguration['itemsPerPage']">
                </app-ui-search>
            </div>
            
            <h3 class="heading">{{UIConfiguration['tableHeading']}}</h3>
            <nz-table *ngIf="filteredDataList && filteredDataList.length > 0" #searchResultTable nzBordered nzShowPagination 
                class="m-t-20" [nzData]="filteredDataList" [nzScroll]="{x: '480px'}">
                <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
                    <tr>
                        <th></th> <!--This empty header is for checkbox used for selection of row-->
                        <ng-container *ngFor="let item of UIConfiguration.searchTableHeaders">
                            <ng-container *ngIf="item.isVisible">
                                <th *ngIf="item.sortFilter && item.searchFilter; else showHeaderWithSortOnly" nzCustomFilter
                                    nzShowSort [nzColumnKey]="item.key" [nzWidth]="item.width">
                                    {{item.header}}
                                    <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu"
                                        (nzVisibleChange)="filterMenuVisibilityChanged($event)">
                                        <i nz-icon nzType="search" (click)="getConfigKey(item.key)"></i>
                                    </nz-filter-trigger>
                                </th>
                                <ng-template #showHeaderWithSortOnly>
                                    <th *ngIf="item.sortFilter; else showSearchFilterOnly" nzShowSort [nzColumnKey]="item.key"
                                        [nzWidth]="item.width">
                                        {{item.header}}
                                    </th>
                                </ng-template>
                                <ng-template #showSearchFilterOnly>
                                    <th *ngIf="item.searchFilter; else showOnlyTableHeader" nzCustomFilter [nzColumnKey]="item.key"
                                        [nzWidth]="item.width">
                                        {{item.header}}
                                        <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu"
                                            (nzVisibleChange)="filterMenuVisibilityChanged($event)">
                                            <i nz-icon nzType="search" (click)="getConfigKey(item.key)"></i>
                                        </nz-filter-trigger>
                                    </th>
                                </ng-template>
                                <ng-template #showOnlyTableHeader>
                                    <th [nzWidth]="item.width">{{item.header}}</th>
                                </ng-template>
            
            
                            </ng-container>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of searchResultTable.data">
                        <td [nzChecked]="setOfCheckedId.has(data.guid)"
                            (nzCheckedChange)="rowSelectionStatusChanged($event, data.guid)"></td>

                        <ng-container *ngFor="let config of UIConfiguration.searchTableHeaders">
                            <ng-container *ngIf="config.isVisible">
                                <td>
                                    <span *ngIf="config.pipe;else showDataOnly">{{ (data[config.key] | technicalTranslate) ||
                                        '-' }}</span>
                                    <ng-template #showDataOnly>{{ data[config.key] || '-' }}</ng-template>
                                </td>
                            </ng-container>
                        </ng-container>
                    </tr>
                </tbody>
            </nz-table>

            <nz-dropdown-menu #searchFilterMenu="nzDropdownMenu">
                <div class="ant-table-filter-dropdown">
                    <div class="search-box">
                        <input type="text" nz-input placeholder="Filter..." [(ngModel)]="searchValue" />
                        <button nz-button nzSize="small" nzType="primary" (click)="searchConfiguration(searchValue)"
                            class="search-button">
                            Filter
                        </button>
                        <button nz-button nzSize="small" (click)="reset()">Reset</button>
                    </div>
                </div>
            </nz-dropdown-menu>

            <app-generic-zero-ui [list]="filteredDataList" icon="file-search" [title]="zeroStateMessageData.title"
                    [message]="zeroStateMessageData.message" [icon]="zeroStateMessageData.icon"></app-generic-zero-ui>

            
            </ng-container>
    </ng-container>

    </div>
</nz-modal>
